import React from 'react';
import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';

const getErrorMessage = (error: Error | string): string => (error instanceof Error ? error.message : error);

export const getErrorsText = (error: Error | Error[] | string | string[]): string =>
  error
    ? Array.isArray(error)
      ? (error as Array<Error | string>).map(getErrorMessage).join('. ')
      : getErrorMessage(error)
    : 'Something went wrong.';

interface Props {
  error?: Error | Error[] | string | string[];
}

export const ErrorMessage: React.FC<Props> = ({ error }: Props) => {
  return (
    <Box m={1}>
      <Alert severity="error">{error ? getErrorsText(error) : 'Something went wrong.'}</Alert>
    </Box>
  );
};
